// Restore this flag when point-card partnerships are available again.
export const POINT_CARD_REDEMPTION_ENABLED = false
